import { Link } from 'react-router-dom';
import { DRIVING_PASS_PRICE, PRO_MONTHLY_PRICE, PRO_YEARLY_PRICE } from '../lib/proPlans';
import { SITE_CONTACT_EMAIL, SITE_DOMAIN, SITE_OPERATOR, SITE_OWNER } from '../lib/siteOperator';

function OperatorNotice() {
  return (
    <div className="space-y-3" data-testid="operator-notice">
      <p>My New Start is operated by {SITE_OPERATOR} ({SITE_DOMAIN}). Owner: {SITE_OWNER}.</p>
      <p>
        Contact <a className="font-semibold text-teal-800 underline" href={`mailto:${SITE_CONTACT_EMAIL}`}>{SITE_CONTACT_EMAIL}</a>.
      </p>
    </div>
  );
}

export function TermsPage() {
  return (
    <div className="font-myanmar mx-auto min-h-screen w-full max-w-lg px-4 py-8" data-testid="terms-page">
      <Link to="/pro" className="text-sm font-semibold text-teal-800">Back</Link>
      <h1 className="mt-4 text-2xl font-semibold text-gray-900">Terms</h1>
      <p className="lesson-subtext mt-1 text-sm text-gray-600">စည်းကမ်းချက်</p>
      <div className="mt-4 space-y-3 text-sm leading-snug text-gray-800">
        <p>Pro is {PRO_MONTHLY_PRICE} a month or {PRO_YEARLY_PRICE} a year. The Driving Pass is {DRIVING_PASS_PRICE}. The Pro screen starts the monthly plan.</p>
        <p>You can cancel from the billing page. Access lasts until the end of the time you already paid for.</p>
        <p>Free lessons stay available without Pro.</p>
        <OperatorNotice />
      </div>
    </div>
  );
}

export function PrivacyPage() {
  return (
    <div className="font-myanmar mx-auto min-h-screen w-full max-w-lg px-4 py-8" data-testid="privacy-page">
      <Link to="/pro" className="text-sm font-semibold text-teal-800">Back</Link>
      <h1 className="mt-4 text-2xl font-semibold text-gray-900">Privacy</h1>
      <p className="lesson-subtext mt-1 text-sm text-gray-600">ကိုယ်ရေးအချက်အလက်</p>
      <div className="mt-4 space-y-3 text-sm leading-snug text-gray-800">
        <p>The daily goal and lesson progress stay on this device until you create an account.</p>
        <p>An account stores your email and the lessons you finish.</p>
        <p>Card payments are handled by Stripe. This site does not store your card number.</p>
        <OperatorNotice />
      </div>
    </div>
  );
}
